<template>
    <div>
        <div><img :src="phone_upload_img" alt="" @click="openPhoto"></div>
    </div>
</template>

<script>
    import {Toast} from 'vant';
    import wx from 'weixin-js-sdk'
    import phone_upload_img from '@/assets/images/phone_upload.png'

    export default {
        name: "Test",
        data() {
            return {
                phone_upload_img: phone_upload_img
            }
        },
        methods: {
            //获取微信js
            getWechatJs() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http.get('/wechat/api.common/getWechatJs', {params: {}}).then(function (response) {
                    Toast.clear();
                    console.log(response);
                    if (response.data && response.data.code == 200) {
                        //配置微信
                        wx.config(JSON.parse(response.data.data));
                    }
                })
            },
            openPhoto() {
                var that = this;
                wx.chooseImage({
                    // 默认9
                    count: 1,
                    // 可以指定是原图还是压缩图，默认二者都有
                    sizeType: ['original', 'compressed'],
                    // 可以指定来源是相册还是相机，默认二者都有
                    sourceType: ['album', 'camera'],
                    success: function (res) {
                        wx.getLocalImgData({
                            localId: res.localIds[0], // 图片的localID
                            success: function (resData) {
                                //alert(JSON.stringify(res));
                                //传递数据
                                that.$http.post('/wechat/api.merchant/uploadMerchantImg',
                                    {
                                        'localId': res.localIds[0],
                                        'type':'sss',
                                        'localData': resData.localData
                                    }
                                ).then(response => {
                                    alert(JSON.stringify(response));
                                }).catch(err => {
                                    console.error("err", err);
                                });


                            }
                        });
                    }
                });
            }
        },
        created() {
            //获取js-sdk数据
            this.getWechatJs();
        }
    }
</script>

<style scoped>

</style>
